// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
// Режим вида ячеек «Stock impact» (Вплив на запас) — бэк T5 (common_modules/cell_views: impact_val / impact_dir).
// Спутник ячейки-даты (§1.2): impact_val = { зона: { мера: количество } } — какие полосы уровней запаса проходит отрезок «остаток до → после»,
// impact_dir: 'in' | 'out' (приход вверх / расход вниз; допускается и { мера: 'in' | 'out' }). Слои — по зонам (цвета CELL_ZONE_COLORS из statusZones.js;
// зона unknown и прочие неизвестные — серым), размер круга — по сумме слоёв; приход — зоны снизу вверх (oos → excess), расход — сверху вниз.
// Подсказка: стрелка направления (↑ приход / ↓ расход) и «было → стало», если грид передал остаток (ctx.stock = { before, after }), иначе только полосы.
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9): реализация (была заглушка T1). Тесты — tests/unit/cellViewStockImpact.test.mjs
import { t as tI18n } from '@/i18n'
import { statusZones_zoneLayers } from './statusZones'

export const STOCK_IMPACT_VIEW = 'stock_impact'
export const STOCK_IMPACT_UNKNOWN_COLOR = '#9e9e9e'

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }
const isObj = (o) => !!o && typeof o === 'object' && !Array.isArray(o)
const isNum = (v) => v !== undefined && v !== null && v !== '' && Number.isFinite(Number(v))

// направление движения ячейки для меры: impact_dir строкой или { мера: dir } → 'in' | 'out' | ''
export function stockImpact_dir(dir, measure) {
    const d = isObj(dir) ? dir[str(measure)] : dir
    const s = str(d).toLowerCase()
    return s === 'in' || s === 'out' ? s : ''
}

// слои по зонам: impactVal — спутник impact_val, measure — мера ячейки, dir — 'in' | 'out' → [{ key, title, value, color, tone }] | null
export function stockImpact_layers(impactVal, measure, dir = '', t = tI18n) {
    const list = statusZones_zoneLayers(impactVal, measure, t)
    if (!list) return null
    const tt = typeof t === 'function' ? t : (x) => x
    for (const l of list) {
        if (str(l.key).toLowerCase() === 'unknown') { l.color = STOCK_IMPACT_UNKNOWN_COLOR; l.title = tt('Unknown') }
        else if (!/^#/.test(str(l.color)) || !l.color) l.color = STOCK_IMPACT_UNKNOWN_COLOR
    }
    return dir === 'out' ? list.reverse() : list
}

export default {
    key: STOCK_IMPACT_VIEW,
    title: 'Stock impact',
    satellites: ['impact_val', 'impact_dir'],
    needsData: true,
    // ctx: { t, date, measure, cell (= dataItem[date]), value, stock?: { before, after } }
    layersOf(dataItem, binding, ctx = {}) {
        const cell = ctx.cell
        if (!isObj(cell)) return null
        const dir = stockImpact_dir(cell.impact_dir, ctx.measure)
        const layers = stockImpact_layers(cell.impact_val, ctx.measure, dir, ctx.t || tI18n)
        if (!layers) return null
        const sum = layers.reduce((s, l) => s + Math.max(0, num(l.value)), 0)
        const st = isObj(ctx.stock) ? ctx.stock : null
        const stock = st && isNum(st.before) && isNum(st.after) ? { before: Number(st.before), after: Number(st.after) } : null
        return { layers, value: sum, dir, stock, satellite: 'impact_val' }
    },
    tipOf(res, ctx = {}) {
        const t = ctx.t || tI18n
        const fmt = typeof ctx.fmt === 'function' ? ctx.fmt : (v) => String(v)
        const note = []
        const dir = res && res.dir
        if (dir) {
            const arrow = dir === 'in' ? '↑' : '↓'
            const what = t(dir === 'in' ? 'Stock goes up' : 'Stock goes down')
            note.push(res.stock ? `${arrow} ${what}: ${fmt(res.stock.before)} → ${fmt(res.stock.after)}` : `${arrow} ${what}`)
        }
        return { caption: t('Stock levels crossed'), note }
    },
    cacheKey(dataItem, ctx = {}) {
        const c = ctx.cell
        if (!isObj(c)) return ''
        const iv = isObj(c.impact_val) ? Object.keys(c.impact_val).length : 0
        return `${stockImpact_dir(c.impact_dir, ctx.measure)}|${iv}`
    },
}
